import { init_graph_call, unauthorized_graphql_call } from './graphql_call';
import { create_state, init_states_storage, create_simple_state } from './create_state.svelte';
import { graph_operations } from './graphdb_handlers';
import { auth_sdk } from './auth_sdk';
import { create_db_map_state, unsubscribe_all_states, reset_all_states, populate_all_auto_populate_states } from './create_db_map_state';

export type FetchFunction = {
   access_token?: string;
   url: string;
   body?: any;
   extra_headers?: Record<string, string>,
   clean_object: (obj: any) => any;
}

export let WS_ENDPOINT = ''

let active_fetch_function: <T>({
   access_token,
   url,
   body,
   extra_headers,
   clean_object
}: FetchFunction) => Promise<T | null> = async <T>({
   access_token,
   url,
   body,
   extra_headers,
   clean_object
}: FetchFunction) => {
      let fetch_options = clean_object({
         headers: {
            'Content-Type': 'application/json',
            Authorization: access_token ? `Bearer ${access_token}` : undefined,
            ...extra_headers
         },
         body: body ? JSON.stringify(body) : undefined,
         method: body ? 'POST' : 'GET'
      }) as any;

      const request = await fetch(url, fetch_options);
      if (!request.ok) return null;
      return request.json() as T;
   };

// import.meta.env.VITE_AUTH_ENDPOINT
export function create_graphdb_client({
   fetch_function,
   graph_endpoint,
   graph_ws_endpoint,
   auth_endpoint,
   requested_role,
   storage = 'indexedDB'
}: {
   fetch_function?: typeof active_fetch_function;
   graph_endpoint: string;
   graph_ws_endpoint?: string;
   auth_endpoint: string;
   requested_role?: string;
   storage: 'localStorage' | 'indexedDB' | 'capacitor';
}) {
   if (fetch_function) active_fetch_function = fetch_function;
   if (graph_ws_endpoint) WS_ENDPOINT = graph_ws_endpoint
   init_states_storage(storage);
   auth_sdk.init({ auth_endpoint, fetch_function: active_fetch_function, requested_role });
   init_graph_call(graph_endpoint, active_fetch_function);
   auth_sdk.on_before_sign_out('reset_all_states_on_before_sign_out', () => reset_all_states())

   return {
      unauthorized_call: unauthorized_graphql_call,
      operations: graph_operations.operations,
      build: graph_operations.build,
      batch: graph_operations.batch,
      unsubscribe_all_states,
      reset_all_states,
      auth: auth_sdk,
      states: {
         create_state,
         create_simple_state,
         create_db_map_state,
         populate_all_auto_populate_states,
      }
   };
}
